/**
 * View component for /sponsors
 *
 * Generic sponsor list view. Defaults to 'all' with:
 * this.props.dispatch(sponsorActions.fetchListIfNeeded());
 *
 * NOTE: See /product/views/ProductList.js.jsx for more examples
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

// import actions
import * as sponsorActions from '../sponsorActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import sponsor components
import SponsorLayout from '../components/SponsorLayout.js.jsx';
import SponsorListItem from '../components/SponsorListItem.js.jsx';

// import sponsor css modules
import sponsorStyles from '../sponsorModuleStyles.css';

class SponsorList extends Base {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    // fetch a list of your choice
    this.props.dispatch(sponsorActions.fetchListIfNeeded()); // defaults to 'all'
  }

  render() {
    const { sponsorStore } = this.props;

    /**
     * Retrieve the list information and the list items for the component here.
     *
     * NOTE: if the list is deeply nested and/or filtered, you'll want to handle
     * these steps within the mapStoreToProps method prior to delivering the
     * props to the component.  Othwerwise, the render() action gets convoluted
     * and potentially severely bogged down.
     */

    // get the sponsorList meta info here so we can reference 'isFetching'
    const sponsorList = sponsorStore.lists ? sponsorStore.lists.all : null;

    /**
     * use the reducer getList utility to convert the all.items array of ids
     * to the actual sponsor objetcs
     */
    const sponsorListItems = sponsorStore.util.getList("all");

    /**
     * NOTE: isEmpty is is usefull when the component references more than one
     * resource list.
     */
    const isEmpty = !sponsorListItems || !sponsorList || sponsorListItems.length === 0;

    return (
      <SponsorLayout>
        <div className="flex">
          <section className="section">
            <div className="yt-container">
              <h1> Sponsors </h1>
              <hr/>
              { isEmpty ?
                  (sponsorListItems && sponsorList && sponsorList.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
                :
                  <div style={{ opacity: sponsorList.isFetching ? 0.5 : 1 }}>
                    <div className="yt-row with-gutters">
                      {sponsorListItems.map((sponsor, i) =>
                        <SponsorListItem key={sponsor._id} sponsor={sponsor} />
                      )}
                    </div>
                  </div>
              }
            </div>
          </section>
        </div>
      </SponsorLayout>
    )
  }
}

SponsorList.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    sponsorStore: store.sponsor
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(SponsorList)
);



// WEBPACK FOOTER //
// modules/sponsor/views/SponsorList.js.jsx